










import { Component } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import FormEmailEdit from "@/components/forms/FormEmailEdit.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";

@Component({
  components: {
    Header,
    FormEmailEdit,
    Footer,
  },
})
export default class MRegisterEmailEdit extends CheckAdminLogin {}
